module.exports = "../content/4470502486a612e2bf6f38d5bff77ce8.ttf";